import {setupKeys,decryptAESKey} from '../src/component/Crypto_Helpers/cryptoHelper'
import Axios from "axios";

// encryptionSession.js
let AES_SESSION_KEY = null;
let RSA_PRIVATE_KEY = null;

export async function initEncryptionSession() {
    if (AES_SESSION_KEY) return AES_SESSION_KEY;

    // Fetch AES key directly from server
    const resp = await Axios.post("/admin/create-session", {module: "D"});
    const aesKey = atob(resp.data.aesKeyBase64);
    // Store as Base64 string
    AES_SESSION_KEY = aesKey;

    return AES_SESSION_KEY;
}

export function aesKeyToBase64(aesKeyUint8) {
  return btoa(String.fromCharCode(...aesKeyUint8));
}

// Optional (on logout)
export function clearEncryptionSession() {
  AES_SESSION_KEY = null;
  RSA_PRIVATE_KEY = null;
}
